import { ActionButton } from '@/common/buttons/ActionButton';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { McoInvFileList } from '../mcoInvFile/McoInvFileList';
import { McoInvLineList } from '../mcoInvLine/McoInvLineList';

export const McoInvDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'invLines', label: 'Lines', content: <McoInvLineList mcoInv={entityObj} /> },
    { id: 'mcoInvFiles', label: 'Managed Care Invoice Files', content: <McoInvFileList mcoBillId={entityObj.id} /> },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="MCO_INV" parentEntityId={entityObj.id} /> }
  ];

  const data = {
        title: 'Managed Care Invoice Lifecycle',
        entity: 'MCO_INV',
        entityId: entityObj.id,
        pluginCode: 'MCO_INV_LIFECYCLE_ACTION_PLUGIN'
    }

  const augButtons = (buttons) => {
    buttons.push(<ActionButton data={data} toolTip="Run Lifecycle" icon={fas.faPlay} />);
  }

  return (
    <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />
  )
}